module.exports = [{
      plugin: require('../plugins/gatsby-plugin-thumbor/gatsby-browser.js'),
      options: {"plugins":[],"breakpoints":[768,1280,1920]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-tagmanager@5.14.0_gatsby@5.16.1_@types+node@25.0.3_@types+webpack@_09d9473f944e4d8f3f378126c62b6801/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-KWZFNV8","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_@types+node@25.0.3_@types+webpack@4.41.40_babel-eslint@10.1.0_eslint@9.34_f440805af9431df061aafb73f00a5993/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
